import { Box } from "@mui/material";
import Header from "../../components/Header";
import LineChart from "../../components/LineChart";
import { useState,useEffect } from "react";
import "../../styles/loader.css"

const Line = () => {
  const [isLoading, setIsLoading] = useState(true); 
  useEffect(() => {
    // Simulate loading delay
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer); // Clean up the timer on unmount
  }, []);

  if (isLoading) {
    return <div className="loader-overlay1">
    <div className="loader1"></div>
  </div> // Render the loader while loading
  }
  return (
    <Box m="20px">
      <Header title="Line Chart" subtitle="Detailed information of products on inventory" />
      <Box height="75vh">
        <LineChart />
      </Box>
    </Box>
  );
};

export default Line;